import React from 'react';
import { Button, Card, Divider, Space, Tag, Typography } from 'antd';
import { CheckCircleOutlined, ReloadOutlined } from '@ant-design/icons';
import { formatCurrency } from 'utils/number';
import { formatDate } from 'utils/date';

const { Text, Title } = Typography;

const TIER_COLORS = {
  mien_phi: 'default',
  mini: 'blue',
  pro: 'purple',
  vip: 'gold',
};

const Mobile = ({ viewModel }) => {
  const { data, loading, approving, onApprove, reload } = viewModel;

  return (
    <div style={{ padding: '0 0 60px' }}>
      <Space style={{ justifyContent: 'space-between', width: '100%', marginBottom: 12 }}>
        <Title level={5} style={{ margin: 0 }}>Yêu cầu nâng cấp</Title>
        <Button size='small' icon={<ReloadOutlined />} onClick={reload} />
      </Space>

      {data.length === 0 && !loading && (
        <Text type='secondary'>Không có yêu cầu nào đang chờ</Text>
      )}

      {data.map((record) => (
        <Card key={record.id} size='small' style={{ marginBottom: 10 }}>
          <Space style={{ justifyContent: 'space-between', width: '100%' }}>
            <Text strong>{record?.workspace?.web_site?.title || record.w_id}</Text>
            <Tag color={TIER_COLORS[record.package_key] || 'default'}>
              {record.package_name || record.package_key}
            </Tag>
          </Space>
          <Divider style={{ margin: '8px 0' }} />
          <Space direction='vertical' size={4} style={{ width: '100%' }}>
            <Space style={{ justifyContent: 'space-between', width: '100%' }}>
              <Text type='secondary'>Kỳ hạn</Text>
              <Text>
                {record.duration_months} tháng
                {record.bonus_months > 0 && ` (+${record.bonus_months} tặng)`}
              </Text>
            </Space>
            <Space style={{ justifyContent: 'space-between', width: '100%' }}>
              <Text type='secondary'>Số tiền</Text>
              <Text strong style={{ color: '#1677ff' }}>{formatCurrency(record.amount)}đ</Text>
            </Space>
            {record.payment_confirmed_on && (
              <Space style={{ justifyContent: 'space-between', width: '100%' }}>
                <Text type='secondary'>Xác nhận TT</Text>
                <Text>{formatDate(record.payment_confirmed_on)}</Text>
              </Space>
            )}
            {record.payment_note && (
              <Text type='secondary' style={{ fontSize: 12 }}>Ghi chú: {record.payment_note}</Text>
            )}
          </Space>
          <Button
            type='primary'
            block
            style={{ marginTop: 10 }}
            icon={<CheckCircleOutlined />}
            loading={approving === record.id}
            onClick={() => onApprove(record)}
          >
            Kích hoạt gói
          </Button>
        </Card>
      ))}
    </div>
  );
};

export default Mobile;
